"use strict";


// Import der Funktion
import initMoveEvents from '../libs/custom/jquery.event.move.js';
import initTwentyTwenty from '../libs/custom/jquery.twentytwenty.js';
import $ from 'jquery';
import 'slick-carousel';

// Initialisierung


export function initInScope($scope) {
    const arrowPrevMarkup = '<button type="button" class="slick-prev slider__arrow" aria-label="Previous"><span class="slider__arrow__icon icon icon-arrow-left"></span></button>';
    const arrowNextMarkup = '<button type="button" class="slick-next slider__arrow" aria-label="Next"><span class="slider__arrow__icon icon icon-arrow-right"></span></button>';
    let $slider = $scope.find('.image-compare-items');
    $slider.each(function () {
        let $slider = $(this);

        let sliderOptions = {
            arrows: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            accessibility: false,
            draggable: false,
            swipe: false,
            touchMove: false,
            fade: true,
        };

        $slider.slick(sliderOptions);

    });

    // Event-Handler für Klick auf image-compare-info-item__js
    $scope.on('click', '.image-compare-info-item__js', function () {
        $scope.find(".image-compare-info-item--active").removeClass("image-compare-info-item--active");
        $(this).addClass("image-compare-info-item--active");
        let $clickedItem = $(this);
        let slideId = $clickedItem.data('id');
        let $nearestSlider = $clickedItem.closest('.image-compare-section').find('.image-compare-items');

        if ($nearestSlider.length && $nearestSlider.hasClass('slick-initialized')) {
            $nearestSlider.slick('slickGoTo', slideId);
        }
    });

    // Mobile Navigation Slider - nur bei <= 767px
    function initMobileNavigation() {
        let $mobileSlickNavigation = $scope.find('.image-compare-info');
        $mobileSlickNavigation.each(function () {
            let $mobileSlickNavigation = $(this);
            let isMobile = window.innerWidth <= 767;
            let isSlickInitialized = $mobileSlickNavigation.hasClass('slick-initialized');

            if (isMobile && !isSlickInitialized) {
                // Initialisiere Slick für Mobile
                let sliderOptionsMobile = {
                    nextArrow: arrowNextMarkup,
                    prevArrow: arrowPrevMarkup,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    infinite: false,
                };

                $mobileSlickNavigation.slick(sliderOptionsMobile);

                // Event-Handler für Slide-Änderung - synchronisiere mit Hauptslider
                $mobileSlickNavigation.on('afterChange', function (event, slick, currentSlide) {
                    let $nearestMainSlider = $(this).closest('.image-compare-section').find('.image-compare-items');
                    $(this).closest('.image-compare-section').find(".image-compare-info-item--active").removeClass("image-compare-info-item--active");
                    $(this).closest('.image-compare-section').find(".image-compare-info-item[data-id='" + currentSlide + "']").addClass("image-compare-info-item--active");
                    if ($nearestMainSlider.length && $nearestMainSlider.hasClass('slick-initialized')) {
                        $nearestMainSlider.slick('slickGoTo', currentSlide);
                    }
                });

            } else if (!isMobile && isSlickInitialized) {
                // Event-Handler entfernen vor dem unslick
                $mobileSlickNavigation.off('afterChange');
                // Zerstöre Slick für Desktop
                $mobileSlickNavigation.slick('unslick');
            }
        });
    }

    // Erste Initialisierung
    initMobileNavigation();

    // Resize Event Listener
    let resizeTimeout;
    window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            initMobileNavigation();
        }, 250);
    });

    window.addEventListener('load', function () {
        initMoveEvents($);
        initTwentyTwenty($);

        // Funktion zum Initialisieren von twentytwenty
        function initTwentyTwentySliders() {
            $('.image-compare-wrapper').each(function () {
                let $wrapper = $(this);
                let offset = $wrapper.data('offset') || 0;

                // Komplettes Cleanup von twentytwenty
                if ($wrapper.hasClass('twentytwenty-container')) {
                    // Event-Handler entfernen
                    $wrapper.off('.twentytwenty');

                    // Alle twentytwenty-wrapper entfernen und Inhalt extrahieren
                    let $content = $wrapper.find('picture, img').detach();

                    // Alle twentytwenty-spezifischen Elemente und Wrapper entfernen
                    $wrapper.find('.twentytwenty-wrapper').each(function () {
                        $(this).replaceWith($(this).contents());
                    });
                    $wrapper.find('.twentytwenty-overlay, .twentytwenty-handle').remove();

                    // CSS-Klassen entfernen
                    $wrapper.removeClass('twentytwenty-container');

                    // Ursprünglichen Inhalt wiederherstellen
                    $wrapper.empty().append($content);

                    // Inline-Styles entfernen die von twentytwenty hinzugefügt wurden
                    $wrapper.removeAttr('style').css('opacity', '');
                    $content.removeAttr('style');
                }

                // Initialisiere twentytwenty neu
                $wrapper.twentytwenty({
                    default_offset_pct: offset, // How much of the before image is visible when the page loads
                    orientation: 'horizontal', // Orientation of the before and after images ('horizontal' or 'vertical')
                    no_overlay: true, //Do not show the overlay with before and after
                    move_slider_on_hover: false, // Move slider on mouse hover?
                    move_with_handle_only: true, // Allow a user to swipe anywhere on the image to control slider movement. 
                    click_to_move: true // Allow a user to click (or tap) anywhere on the image to move the slider to that location.
                });
                $wrapper.css('opacity', 1);
            });
        }

        // Erste Initialisierung
        initTwentyTwentySliders();
        $(".image-compare-info").css('opacity', 1);

        // Resize Event Listener für TwentyTwenty
        let twentyTwentyResizeTimeout;
        window.addEventListener('resize', function () {
            clearTimeout(twentyTwentyResizeTimeout);
            twentyTwentyResizeTimeout = setTimeout(function () {
                initTwentyTwentySliders();
            }, 250);
        });
    });
}